import { render, staticRenderFns } from "./OverdueDsar.vue?vue&type=template&id=abc6f8f8&scoped=true&"
import script from "./OverdueDsar.vue?vue&type=script&lang=js&"
export * from "./OverdueDsar.vue?vue&type=script&lang=js&"
import style0 from "./OverdueDsar.vue?vue&type=style&index=0&id=abc6f8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc6f8f8",
  null
  
)

export default component.exports